import Image from 'next/image';

import styles from './ChallengesSection.module.scss';

const ChallengesSection = () => {
  return (
    <section className={styles.challengesSection}>
      <div className={styles.quoteSection}>
        <div className={styles.imageContainer}>
          <Image
            src="/images/landing_page_pipfarm/image4.png"
            alt="Profile Picture"
            width={225}
            height={221}
            className={styles.profileImage}
          />
        </div>
        <div className={styles.quoteContainer}>
          <p className={styles.quote}>
            Trong chưa đầy một năm, chúng tôi đã chứng minh cho hơn mười ngàn nhà giao dịch trên
            toàn cầu rằng họ có thể tin tưởng chúng tôi. Giờ đây, chúng tôi có một cộng đồng lớn các
            nhà giao dịch được cấp vốn đang thu lợi nhuận hàng ngày. Khi nhà giao dịch thấy rằng
            PipFarm không ngại những nhà giao dịch thành công, họ bắt đầu tin tưởng.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChallengesSection;
